import type { ComponentSchema } from '../../../../../schema-types'
import { CONTENT_PAGES, headingFields, SECTION_STYLE_FIELDS } from './_fields'

/** A grape band with a short pitch and one button (school kits, return gifts, party and bulk orders). */
export const schema: ComponentSchema = {
  type: 'corporate-band',
  label: 'Bulk order band',
  description: 'Text and one button, e.g. for school kits, return gifts or birthday party orders.',
  supportedPages: CONTENT_PAGES,
  variants: [{ id: 'v1', label: 'Text and button' }],
  commonFields: [
    ...headingFields({ eyebrow: { en: 'Schools & parties', bn: 'স্কুল ও পার্টি' }, title: { en: 'Ordering for a class or a birthday?', bn: 'ক্লাস বা জন্মদিনের জন্য অর্ডার?' } }).filter(f => f.key !== 'subtitle'),
    { key: 'text', label: 'Text', type: 'localized-text', default: { en: 'Return gifts, class kits or a party table: get bulk prices and delivery on the day you need it.', bn: 'রিটার্ন গিফট, ক্লাস কিট বা পার্টির জিনিস: বাল্ক দামে, আপনার দিনে ডেলিভারি।' } },
    { key: 'cta.label', label: 'Button text', type: 'localized-string', default: { en: 'Ask for a quote', bn: 'দাম জানতে চান' } },
    { key: 'cta.url', label: 'Button link', type: 'string', default: '/contact' },
    ...SECTION_STYLE_FIELDS,
  ],
}
